import { useCallback, useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronLeft, faChevronRight, faChevronUp } from '@fortawesome/free-solid-svg-icons'

const xRoutes = ['/', '/ames-family-history', '/ames-change-makers', '/ames-family-at-work']
let yRoutes = []
const initialYRoutes = ['/ames-family-history', '/ames-family-history/family']

export default function ArrowNav ({ data }) {
  const location = useLocation()
  const navigate = useNavigate()

  const [showUp, setShowUp] = useState(false)
  const [showDown, setShowDown] = useState(false)
  const [showLeft, setShowLeft] = useState(false)
  const [showRight, setShowRight] = useState(true)

  const getCurrentXIndex = useCallback(() => {
    const index = xRoutes.findIndex((path) => path !== '/' && location.pathname.includes(path.replace('/', '')))
    return index !== -1 ? index : 0
  }, [location.pathname])

  const getCurrentYIndex = useCallback(() => {
    const index = yRoutes.findIndex((path) => path === location.pathname)
    return index !== -1 ? index : 0
  }, [location.pathname])

  const xIndex = useRef(getCurrentXIndex())
  const yIndex = useRef(0)

  function handleNavigation (dir) {
    switch (dir) {
      case 'up':
        if (yIndex.current > 0) {
          yIndex.current -= 1
          if (yIndex.current >= 2) {
            navigate(yRoutes[yIndex.current], { state: { direction: 'default' } })
          } else {
            navigate(yRoutes[yIndex.current], { state: { direction: 'down' } })
          }
        }
        break
      case 'down':
        if (yIndex.current < yRoutes.length - 1) {
          yIndex.current += 1
          if (yIndex.current >= 2) {
            navigate(yRoutes[yIndex.current], { state: { direction: 'default' } })
          } else {
            navigate(yRoutes[yIndex.current], { state: { direction: 'up' } })
          }
        }
        break
      case 'left':
        if (xIndex.current > 0) {
          xIndex.current -= 1
          if (yIndex.current !== 0 && xIndex.current === 1) {
            navigate(yRoutes[yIndex.current], { state: { direction: 'right' } })
          } else {
            navigate(xRoutes[xIndex.current], { state: { direction: 'right' } })
          }
        }
        break
      case 'right':
        if (xIndex.current < xRoutes.length - 1) {
          xIndex.current += 1
          navigate(xRoutes[xIndex.current], { state: { direction: 'left' } })
        }
        break
      default:
        break
    }
  }

  useEffect(() => {
    xIndex.current = getCurrentXIndex()
    if (xIndex.current === 0 || location.pathname === '/ames-family-history') {
      yIndex.current = 0
    }

    const peopleRoutes = data.people.map((person) => {
      return `/ames-family-history/${person.key}`
    })
    yRoutes = [...initialYRoutes, ...peopleRoutes]

    if (location.pathname.includes('/ames-family-history/')) {
      yIndex.current = getCurrentYIndex()
    }

    console.log(xIndex.current, yIndex.current)

    const x = xIndex.current
    const y = yIndex.current
    if (x === 0) {
      setShowLeft(false)
      setShowRight(true)
    } else if (x === xRoutes.length - 1) {
      setShowLeft(true)
      setShowRight(false)
    } else {
      setShowLeft(true)
      setShowRight(true)
    }

    if (y === 0 && x === 1) {
      setShowUp(false)
      setShowDown(true)
    } else if (y === yRoutes.length - 1 && x === 1) {
      setShowUp(true)
      setShowDown(false)
    } else if (x === 1) {
      setShowUp(true)
      setShowDown(true)
    } else {
      setShowUp(false)
      setShowDown(false)
    }
  }, [location, data.people, getCurrentXIndex, getCurrentYIndex])

  return (
    <aside className={`arrow-nav ${yIndex.current >= 2 && xIndex.current === 1 ? 'black' : ''}`}>
      {showUp && (
        <button className='btn-up' onClick={() => handleNavigation('up')}>
          <FontAwesomeIcon icon={faChevronUp} />
        </button>
      )}
      {showDown && (
        <button className='btn-down'>
          <FontAwesomeIcon icon={faChevronDown} onClick={() => handleNavigation('down')} />
        </button>
      )}
      {showLeft && (
        <button className='btn-left'>
          <FontAwesomeIcon icon={faChevronLeft} onClick={() => handleNavigation('left')} />
        </button>
      )}
      {showRight && (
        <button className='btn-right'>
          <FontAwesomeIcon icon={faChevronRight} onClick={() => handleNavigation('right')} />
        </button>
      )}
    </aside>
  )
}
